import React from 'react';
import { Heading } from '@flixbus/honeycomb-react';
import styles from './upload-csv-file-input.module.scss';
import FileUploadButton from '../FileUploadButton/FileUploadButton';

type UploadCSVFileInputProps = {
  file: File | null;
  // eslint-disable-next-line no-unused-vars
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemove: () => void;
  inputRef: React.RefObject<HTMLInputElement>;
};

const UploadCSVFileInput: React.FC<UploadCSVFileInputProps> = ({
  file,
  onFileChange,
  onRemove,
  inputRef,
}) => {
  return (
    <div className={styles.container}>
      <Heading size={3} flushSpace extraClasses={styles.title}>
        Upload file
      </Heading>

      <FileUploadButton
        file={file}
        onFileChange={onFileChange}
        onRemove={onRemove}
        inputRef={inputRef}
      />
    </div>
  );
};

export default UploadCSVFileInput;
